module.exports = __webpack_public_path__ + "static/media/wave_hero_user.e9161b07.svg";